var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSigninCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.552,
    height: 130.552,
    viewBox: "0 0 130.552 130.552",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "signin-circle",
    transform: "translate(-1198.085 -438.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M1310.116,500.872a46.818,46.818,0,1,1-44.319-44.319A46.822,46.822,0,0,1,1310.116,500.872Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M1310.116,500.872a46.818,46.818,0,1,1-44.319-44.319A46.822,46.822,0,0,1,1310.116,500.872Z",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M1263.361,568.584c-.711,0-1.42-.011-2.137-.034a65.277,65.277,0,0,1,2.138-130.518c.711,0,1.418.011,2.135.034a65.276,65.276,0,0,1-2.136,130.518Zm0-128.552a63.216,63.216,0,1,0,2.07.032C1264.738,440.043,1264.051,440.032,1263.362,440.032Z",
    fill: "#6c5b7b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninCircle);
export default __webpack_public_path__ + "static/media/signin-circle.bd071818bee59eadccb804618a9e6229.svg";
export { ForwardRef as ReactComponent };